import { CommonLayout, } from '../commonComponents';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { Theme } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { getApplicationDetails } from '../../redux-store/actions/application';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Box, Button, Grid, IconButton, LinearProgress, Typography, useTheme } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Link as RouterLink, useHistory, useParams } from 'react-router-dom';
import { ApplicationDetailsCommonLayout } from '../ApplicationDetails';
import { EditIcon } from '../../assets/SvgIcons';
import { APPLICATION_LISTING_STATUS, APPLICATION_RE_KYC_STATUS, USER_ROLES } from '../../utils/constant';
import NomineeDetails from '../ApplicationDetails/nomineeDetails';
import BankDetails from '../ApplicationDetails/BankDetails';
import PersonalDetails from '../ApplicationDetails/personalDetails';
import DocumentDetails from '../ApplicationDetails/DocumentDetails';


const JointHolderApplication = ({ loading, application }: { loading: boolean, application: ApplicationProps }) => {
  return (
    <>
      {loading && <LinearProgress />}
      {application && !loading &&
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: '36px',
              mt: '24px',
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: '5px', width: 'fit-content', p: '10px', backgroundColor: 'customColors.offGreen', borderRadius: '10px' }}>
              <Typography variant="body_500" color="customColors.greenText">
                BSE Star UCC Code:
              </Typography>
              <Typography variant="body_600" color="customColors.greenText">
                037599
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: '5px', width: 'fit-content', p: '10px', backgroundColor: 'customColors.offGreen', borderRadius: '10px' }}>
              <Typography variant="body_500" color="customColors.greenText">
                mPower Porfolio code:
              </Typography>
              <Typography variant="body_600" color="customColors.greenText">
                45877164
              </Typography>
            </Box>
          </Box>
          <PersonalDetails
            applicants={application.applicants}
            modeOfHolding={application.modeOfHolding}
          />
          <NomineeDetails nominees={application.nominees} application={application} />
          <BankDetails banks={application.banks} />
          <DocumentDetails application={application} />
        </>
      }
    </>
  )
}


export const JointHolderDetails = (): JSX.Element => {
  const theme = useTheme();
  const { id } = useParams<{ id: string }>();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState<ApplicationProps>();
  const [isCurrentStatusNotDraft, setCurrentStatusNotDraft] = useState<boolean>(false);
  const applicationDetailRef = useRef<HTMLDivElement>();

  useEffect(() => {
    (async function () {
      try {
        const _application = (await dispatch(
          getApplicationDetails(id)
        )) as unknown as ApplicationProps;
        setApplication(_application);
        setCurrentStatusNotDraft(_application?.status?.toLowerCase() !== 'draft')
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, []);

  return (
    <CommonLayout>
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: "20px"
          }}
        >
          {/* <Typography variant='h2' sx={{ color: 'text.primary', marginLeft: "35px" }}>
            Joint Holder Investor Application
          </Typography> */}
        </Box>
        <Grid container sx={(theme: Theme) => ({
          p: "35px",
          border: `1px solid ${theme.palette.text.secondary}26`,
          borderRadius: "15px",
          background: theme.palette.background.paper,
          position: 'relative'
        })}>
          <Grid item
            container
            xs={12}
          >
            <Box component={'div'} style={{ padding: '35px', border: `1px solid ${theme.palette.text.secondary}26`, borderRadius: '15px', backgroundColor: `${theme.palette.common.white}`, width: '100%' }}>
              <Box
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 5 }}
                ref={applicationDetailRef}>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', }}>
                    <Box >

                      <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                        <Typography
                          variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                        >
                          Application ID:{' '}
                        </Typography>
                        <Typography
                          variant="inherit"
                          sx={{
                            fontWeight: '400',
                            ...theme.typography.body_500,
                            display: 'inline',
                            color: 'text.primary',

                          }}
                        >
                          {application?.applicationNumber}
                        </Typography>
                      </Typography>

                      <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                        <Typography
                          variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                        >
                          Status:{' '}
                        </Typography>
                        <Typography
                          variant="inherit"
                          sx={(theme: Theme) => ({
                            fontWeight: '400',
                            ...theme.typography.body_500,
                            display: 'inline',
                            color: application?.status === 'draft' ? theme.palette.primary[500] : theme.palette.warning[500],
                            textTransform: 'capitalize'

                          })}
                        >
                          {`${APPLICATION_LISTING_STATUS[application?.status ?? '']} ${application?.applicationSentBack ? '(Sent Back)' : ''}`}
                        </Typography>
                      </Typography>
                      {application?.rekycStatus &&
                        <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                          <Typography
                            variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                          >
                            Re-KYC Status:{' '}
                          </Typography>
                          <Typography
                            variant="inherit"
                            sx={(theme: Theme) => ({
                              fontWeight: '400',
                              ...theme.typography.body_500,
                              display: 'inline',
                              color: application?.rekycStatus === 'completed' ? theme.palette.success[500] : theme.palette.primary[500], textTransform: 'capitalize'

                            })}
                          >
                            {APPLICATION_RE_KYC_STATUS[application?.rekycStatus ?? '']}
                          </Typography>
                        </Typography>
                      }
                    </Box>
                    {application?.clientCode &&
                      <Box>
                        <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                          <Typography
                            variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                          >
                            Client Code:{' '}
                          </Typography>
                          <Typography
                            variant="inherit"
                            sx={{
                              fontWeight: '400',
                              ...theme.typography.body_500,
                              display: 'inline',
                              color: 'text.primary',

                            }}
                          >
                            {application?.clientCode}
                          </Typography>
                        </Typography>
                      </Box>
                    }
                  </Box>
                </Box>
                {/* {[USER_ROLES.RM].includes(role) && <Button
                  variant="outlined"
                  startIcon={<EditIcon />}
                  sx={(theme: Theme) => ({
                    padding: '15px',
                    border: `0.5px solid ${theme.palette.text.secondary}`,
                    borderRadius: '10px',
                    color: theme.palette.text.secondary,
                    fontFamily: theme.typography.fontFamily,
                    fontSize: '18px',
                    fontWeight: 700,
                    cursor: 'pointer',

                  })}
                  onClick={() => history.push(`/create-account`, { id })}
                >
                  Edit
                </Button>} */}
              </Box>
              <JointHolderApplication
                loading={loading}
                application={application as ApplicationProps}
              />
            </Box>
          </Grid>
        </Grid>
        {/* <IconButton
          sx={{
            position: 'fixed',
            right: 0,
            bottom: 75,
            borderRadius: '5px  0 0 5px',
            '&,:hover': {
              bgcolor: 'primary.main',
            },
          }}
          onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
        </IconButton> */}
      </>
    </CommonLayout>
  )

};